import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AppColumnComponent } from './app-column.component'

@NgModule({
  declarations: [AppColumnComponent],
  imports: [CommonModule],
  exports: [AppColumnComponent],
})
export class AppColumnModule {}
